import { z } from 'zod';

const AuditSchema = z.object({
  createdOn: z.string(),
  createdBy: z.string().nullable(),
  modifiedOn: z.string(),
  modifiedBy: z.string().nullable(),
});

const DemographicsSchema = z.object({
  businessType: z.string().nullable(),
  businessTypeFreetext: z.string().nullable(),
});

const PhysicalAddressSchema = z
  .object({
    addressLine1: z.string(),
    addressLine2: z.string().nullable(),
    addressLine3: z.string().nullable(),
    city: z.string(),
    stateCode: z.string().nullable(),
    stateName: z.string().nullable(),
    postalCode: z.string(),
    countryCode: z.string(),
  })
  .nullish();

export const CustomerSchema = z.object({
  audit: AuditSchema.nullish(),
  canadianAntiSpamLevel: z.number().nullish(),
  communityScreenName: z.string().nullish(),
  confirmedOptIn: z.boolean().nullish(),
  contactEmail: z.string().nullish(),
  contactPhone: z.string().nullish(),
  organizationPhone: z.string().nullish(),
  countryCode: z.string(),
  customerId: z.number(),
  encodedAccountId: z.string(),
  demographics: DemographicsSchema,
  derelict: z.boolean(),
  firstName: z.string(),
  inMaintenanceMode: z.boolean(),
  lastName: z.string(),
  organizationName: z.string(),
  partnerAccountId: z.string().nullable(),
  partnerId: z.number(),
  phonePrefix: z.string().nullable(),
  phoneRemainder: z.string().nullable(),
  stateCode: z.string().nullable(),
  timeZoneId: z.string(),
  timeZoneStatus: z.string(),
  website: z.string().nullable(),
  physicalAddress: PhysicalAddressSchema,
});

export type CustomerResponse = z.infer<typeof CustomerSchema>;
